import { EnvironmentConfig, EnvironmentVariables } from './environment.types';
import { environmentConfig } from './environment.config';

export const environment: EnvironmentVariables = {
  ...environmentConfig,
  isProduction: environmentConfig.ENV === 'production',
  isDevelopment: environmentConfig.ENV === 'development',
  isStaging: environmentConfig.ENV === 'staging',
};

const validateEnvironment = () => {
  const requiredVars: (keyof EnvironmentConfig)[] = ['API_URL'];
  const missingVars = requiredVars.filter((key) => !environment[key]);
  if (missingVars.length > 0) {
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }
};

if (process.env.NODE_ENV !== 'test') {
  validateEnvironment();
}
